import { InternalAxiosRequestConfig } from 'axios'

export const getBaseUrl = async (config: InternalAxiosRequestConfig) => {
  config.baseURL = `${window.env('API_URL')}/v1`

  return config
}
